import { Grid, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormikTextField } from "../../../components/Layout/FormikTextField";
import { CountriesList } from "../types/processTypes";

export const AddressDetail = () => {
  const { t } = useTranslation();
  const { t: te } = useTranslation("enums");
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="address.telephone"
            label={t("telephone")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="address.alternateTelephone"
            label={t("alternateTelephone")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField formikKey="address.city" label={t("city")} />
        </Grid>
        <Grid item md={8} xs={12}>
          <FormikTextField
            formikKey="address.streetAddress"
            label={t("address")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="address.country"
            select
            label={t("country")}
          >
            {Object.keys(CountriesList).map((option) => (
              <MenuItem key={option} value={option as string}>
                {te((option as string).toLowerCase())}
              </MenuItem>
            ))}
          </FormikTextField>
        </Grid>
      </Grid>
    </div>
  );
};
